import { getSourceProjects } from '@lib/api'
import { sourceProjectsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useSourceProjects = (projectIntegrationId: number) => {
  return useQuery(sourceProjectsKeys.all, () =>
    getSourceProjects(projectIntegrationId),
  )
}
